import React, { useEffect, useRef, useState } from "react";

import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import {
  productList,
  purchaseApi,
  vendorList,
} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { BrowserMultiFormatReader } from "@zxing/library";

const PurchaseBillAdd = () => {
  const [allproduct, setAllProduct] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [supplier, setSupplier] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [gst, setGst] = useState("");
  const [billNo, setBillNo] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [billDate, setBillDate] = useState("");
  const [billTime, setBillTime] = useState("");
  const [product, setProduct] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [payment, setPaymentMode] = useState("");
  const [items, setItems] = useState([]);
  const [payableAmount, setPayableAmount] = useState("");
  const [dueAmount, setDueAmount] = useState("");
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [barcode, setBarcode] = useState("");

  const fileInputRef = useRef(null);

  const handlePayableChange = (e) => {
    const value = parseFloat(e.target.value);
    setPayableAmount(value);
    setDueAmount(parseFloat(grandTotal - value));
  };

  const calculateTotal = () => {
    let subtotal = 0;
    let totalCgst = 0;
    let totalSgst = 0;
    let totalIgst = 0;

    items.forEach((item) => {
      const totalAmount = item.quantity * item.price;
      subtotal += totalAmount;
      totalCgst += (totalAmount * item.cgst) / 100;
      totalSgst += (totalAmount * item.sgst) / 100;
      totalIgst += (totalAmount * item.igst) / 100;
    });

    return {
      subtotal,
      totalCgst,
      totalSgst,
      totalIgst,
      grandTotal: subtotal + totalCgst + totalSgst + totalIgst,
    };
  };

  const { subtotal, totalCgst, totalSgst, totalIgst, grandTotal } =
    calculateTotal();

  useEffect(() => {
    const fetchVendorList = async () => {
      try {
        const response = await vendorList(token);
        console.log("Vendor : ", response);
        setVendor(response);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    fetchVendorList();
  }, []);

  useEffect(() => {
    const fetchVendorList = async () => {
      try {
        const response = await vendorList(token);
        setVendor(response);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      }
    };
    fetchVendorList();
  }, []);

  useEffect(() => {
    const fetchProductList = async () => {
      try {
        const response = await productList(token);
        setAllProduct(response.products);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProductList();
  }, []);

  const handleSupplierChange = (e) => {
    const selectedSupplier = e.target.value;
    setSupplier(selectedSupplier);
    const selectedVendor = vendor.find((v) => v.id == selectedSupplier);
    setGstNumber(selectedVendor ? selectedVendor.vendorGstNumber : "");
  };

  const handlePayableAmount = (e) => {
    console.log("e.target.value : ", e.target.value);
    setPaymentMode(e.target.value);
  };

  const handleProductChange = (e) => {
    const selectedProductId = e.target.value;
    console.log("selectedProductId : ", e.target.value);
    setSelectedProduct(e.target.value);

    const selectedProductData = allproduct.find(
      (v) => v.id == selectedProductId
    );
    console.log("selectedProductData : ", selectedProductData);
    setGst(selectedProductData.productGst);

    if (selectedProductData) {
      const gstValue = parseFloat(
        selectedProductData.productGst.replace("%", "")
      );

      let cgst = 0,
        sgst = 0,
        igst = 0;

      if (gstValue === 18) {
        cgst = gstValue / 2;
        sgst = gstValue / 2;
      } else {
        igst = gstValue;
      }

      setItems((prevItems) => [
        ...prevItems,
        {
          id: selectedProductData.id,
          name: selectedProductData.productName,
          quantity: 1,
          stock: selectedProductData.stock,
          serialNumbers: [{ num: "x" }],
          price: selectedProductData.purchasePrice,
          gst: gstValue,
          cgst,
          sgst,
          igst,
        },
      ]);
    }
  };

  const handleRemoveRow = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const updateItemGst = (gstValue) => {
    if (typeof gstValue === "string") {
      gstValue = gstValue.replace("%", ""); // Remove percentage sign
    }

    gstValue = parseFloat(gstValue);

    if (isNaN(gstValue)) {
      console.error("Invalid GST Value:", gstValue);
      return;
    }

    console.log("Clean GST Value:", gstValue);

    setItems((prevItems) =>
      prevItems.map((item) => {
        let cgst = 0,
          sgst = 0,
          igst = 0;

        if (gstValue > 0) {
          if (gstValue === 18) {
            cgst = gstValue / 2;
            sgst = gstValue / 2;
          } else {
            igst = gstValue;
          }
        }

        return {
          ...item,
          gst: gstValue,
          cgst,
          sgst,
          igst,
        };
      })
    );
  };

  const handleAddRow = () => {
    setItems([
      ...items,
      { name: "", quantity: 1, rate: 0, gst: "", cgst: 0, sgst: 0, igst: 0 },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    let list = newItems[index].serialNumbers;

    if (value < 1) {
      return;
    }

    if (list.length < value) {
      list.push({ num: "" });
      console.log(newItems[index].serialNumbers.length);
    } else {
      list.pop();
      console.log(newItems[index].serialNumbers.length);
    }
    newItems[index].serialNumbers = list;

    const totalAmount = newItems[index].quantity * newItems[index].rate;
    const gstValue = parseFloat(newItems[index].gst) || 0;

    let cgst = 0,
      sgst = 0,
      igst = 0;

    if (gstValue === 18) {
      cgst = 9;
      sgst = 9;
      igst = 0;
    } else {
      cgst = 0;
      sgst = 0;
      igst = gstValue;
    }

    newItems[index].cgst = cgst;
    newItems[index].sgst = sgst;
    newItems[index].igst = igst;
    newItems[index].cgstAmount = (totalAmount * cgst) / 100;
    newItems[index].sgstAmount = (totalAmount * sgst) / 100;
    newItems[index].igstAmount = (totalAmount * igst) / 100;
    newItems[index].finalAmount =
      totalAmount +
      newItems[index].cgstAmount +
      newItems[index].sgstAmount +
      newItems[index].igstAmount;

    setItems(newItems);
  };

  const serialNumberList = (list) => {
    console.log(list);

    return list.map((i) => ({ serialNumber: i.num }));
  };

  const handleSubmit = async () => {
    console.log("items : ", items);
    if (!supplier || !billNo || !purchaseDate || !billDate || !billTime) {
      toast.error("Please fill all required fields");
      return;
    }

    const data = {
      vendorId: supplier,
      billNo,
      purchaseDate,
      billDate,
      billTime,
      subTotal: subtotal.toFixed(2),
      grandTotal: grandTotal.toFixed(2),
      totalCgst: totalCgst.toFixed(2),
      totalSgst: totalSgst.toFixed(2),
      totalIgst: totalIgst.toFixed(2),

      payableAmount: (grandTotal - dueAmount).toFixed(2),
      dueAmount: parseFloat(dueAmount).toFixed(2),
      paymentMode: payment,
      purchaseItems: items.map((item) => ({
        productId: item.id,
        purchaseRate: item.price,
        quantity: item.quantity,
        purchaseCgst: item.cgst.toFixed(2),
        purchaseSgst: item.sgst.toFixed(2),
        purchaseIgst: item.igst.toFixed(2),
        purchasePrice: item.quantity * item.price,
        purchaseCgstAmt: (item.cgst * item.price) / 100,
        purchaseSgstAmt: (item.sgst * item.price) / 100,
        purchaseIgstAmt: (item.igst * item.price) / 100,
        itemDetails: serialNumberList(item.serialNumbers),
        taxAmount: (item.price * item.quantity).toFixed(2),
      })),
    };

    console.log("data : ", data);

    try {
      const response = await purchaseApi(data, token);
      console.log("Purchase API Response:", response);

      if (response.status === 200) {
        toast.success("Purchase entry added successfully");
        setSupplier("");
        setBillNo("");
        setPurchaseDate("");
        setBillDate("");
        setBillTime("");
        setItems([]);
        setGst("");
        setPayableAmount("");
        setDueAmount("");
        setGstNumber("");
        setSelectedProduct("");
        setPaymentMode("");
      } else {
        toast.error(response.data?.message || "Failed to add purchase entry");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error adding purchase entry");
    }
  };

  useEffect(() => {
    const fetchVendorList = async () => {
      try {
        const response = await vendorList(token);
        setVendor(response);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      }
    };
    fetchVendorList();
  }, []);

  useEffect(() => {
    const fetchProductList = async () => {
      try {
        const response = await productList(token);
        setAllProduct(response.products);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProductList();
  }, []);

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImageChange = async (e, item, i, index) => {
    const file = e.target.files[0];
    if (file) {
      // await  handleUploadQr(file)
      const reader = new FileReader();
      reader.onload = async () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = async () => {
          try {
            const codeReader = new BrowserMultiFormatReader();
            const result = await codeReader.decodeFromImageElement(img);
            setBarcode(result.getText()); // store unique code
            console.log("code data", result.getText());
            let fullList = [...items];
            let list = [...item.serialNumbers];
            list[i].num = result.getText();
            fullList[index].serialNumbers = [...list];
            setItems(fullList);
          } catch (err) {
            toast.info("Could not read barcode. Try a clearer image.");
            console.error(err);
          }
        };
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page pb-page">
        <Section />
        <div className="purchase-container pb-container">
          {/* ================= TITLE ================= */}
          <div className="pb-title-bar">
            <div>
              <h2 className="pb-title">Purchase Entry</h2>
              <p className="pb-title-sub">Record a vendor bill, add products and serial numbers.</p>
            </div>
            <span className="pb-title-icon">
              <i className="fa fa-file-text-o" />
            </span>
          </div>

          <div className="pb-top">
            {/* ================= LEFT : BILL DETAILS ================= */}
            <div className="pb-card">
              <div className="pb-card-head">
                <span className="pb-card-icon">
                  <i className="fa fa-truck" />
                </span>
                <h3>Bill details</h3>
              </div>
              <div className="pb-card-body pb-form-grid">
                <div className="form-group pb-field">
                  <label>Vendor Name</label>
                  <select value={supplier} onChange={handleSupplierChange}>
                    <option value="">-- Select --</option>
                    {vendor.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.firstName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group pb-field">
                  <label>GST Number</label>
                  <input type="text" value={gstNumber} readOnly />
                </div>

                <div className="form-group pb-field">
                  <label>Bill No</label>
                  <input
                    type="text"
                    value={billNo}
                    onChange={(e) => setBillNo(e.target.value)}
                  />
                </div>

                <div className="form-group pb-field">
                  <label>Purchase Date</label>
                  <input
                    type="date"
                    value={purchaseDate}
                    onChange={(e) => setPurchaseDate(e.target.value)}
                  />
                </div>

                <div className="form-group pb-field">
                  <label>Bill Date</label>
                  <input
                    type="date"
                    value={billDate}
                    onChange={(e) => setBillDate(e.target.value)}
                  />
                </div>

                <div className="form-group pb-field">
                  <label>Bill Time</label>
                  <input
                    type="time"
                    value={billTime}
                    onChange={(e) => setBillTime(e.target.value)}
                  />
                </div>

                <div className="form-group pb-field">
                  <label>Product Name</label>
                  <select value={selectedProduct} onChange={handleProductChange}>
                    <option value="">-- Select --</option>
                    {allproduct?.map((product) => (
                      <option key={product?.id} value={product?.id}>
                        {product?.productName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group pb-field">
                  <label>Product Gst</label>
                  <input type="text" value={gst} readOnly />
                </div>
              </div>
            </div>

            {/* ================= RIGHT : SUMMARY + PAYMENT ================= */}
            <div className="pb-side">
              <div className="pb-summary summary">
                <p className="pb-sum-title">
                  <i className="fa fa-calculator" /> Bill summary
                </p>
                <p className="pb-sum-row">
                  <span>Subtotal</span>
                  <b>₹{subtotal.toFixed(2)}</b>
                </p>
                <p className="pb-sum-row">
                  <span>Total CGST</span>
                  <b>₹{totalCgst.toFixed(2)}</b>
                </p>
                <p className="pb-sum-row">
                  <span>Total SGST</span>
                  <b>₹{totalSgst.toFixed(2)}</b>
                </p>
                <p className="pb-sum-row">
                  <span>Total IGST</span>
                  <b>₹{totalIgst.toFixed(2)}</b>
                </p>
                <p className="grand-total pb-grand">
                  <span>Grand Total</span>
                  <b>₹{grandTotal.toFixed(2)}</b>
                </p>
              </div>

              <div className="pb-card">
                <div className="pb-card-head">
                  <span className="pb-card-icon">
                    <i className="fa fa-credit-card" />
                  </span>
                  <h3>Payment</h3>
                </div>
                <div className="pb-card-body">
                  <div className="form-group pb-field">
                    <label>Payment Mode</label>
                    <select value={payment} onChange={handlePayableAmount}>
                      <option value="">-- Select --</option>
                      <option value="Cash">Cash</option>
                      <option value="Credit">Credit</option>
                    </select>
                  </div>
                  <div className="form-group pb-field">
                    <label>Payable Amount</label>
                    <input
                      type="number"
                      value={payableAmount}
                      onChange={handlePayableChange}
                    />
                  </div>
                  <div className="form-group pb-field">
                    <label>Due Amount</label>
                    <input type="number" value={dueAmount} readOnly />
                  </div>
                  <div className="form-group">
                    <button onClick={handleSubmit} className="pb-submit">
                      <i className="fa fa-check-circle" /> Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= ITEMS TABLE ================= */}
          <div className="pb-card pb-items">
            <div className="pb-card-head">
              <span className="pb-card-icon">
                <i className="fa fa-cubes" />
              </span>
              <h3>Items</h3>
              <span className="pb-count">{items.length}</span>
            </div>
            <div className="pb-table-wrap">
              <table className="pb-table">
                <thead>
                  <tr>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Serial Numbers & Ear</th>
                    <th>Purchase Rate</th>
                    <th>Tax Amount</th>
                    <th>CGST (%)</th>
                    <th>SGST (%)</th>
                    <th>IGST (%)</th>
                    <th>Purchase Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input type="text" value={item.name} readOnly className="pb-name" />
                      </td>
                      <td>
                        <div className="pb-qty">
                          <button
                            className="pb-qty-btn"
                            onClick={() => {
                              if (item.quantity === 1) {
                                return;
                              }
                              handleItemChange(index, "quantity", item.quantity - 1);
                            }}
                          >
                            -
                          </button>
                          <p className="pb-qty-num">{item.quantity}</p>
                          <button
                            className="pb-qty-btn"
                            onClick={() => {
                              if (item.stock === item.quantity) {
                                return;
                              }
                              handleItemChange(index, "quantity", item.quantity + 1);
                            }}
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="pb-serial-cell">
                        <div className="pb-serial-box">
                          {item.serialNumbers.map((ele, i) => (
                            <div className="pb-serial-row" key={i}>
                              <input
                                className="pb-serial-input"
                                type="text"
                                value={ele.num}
                                placeholder="enter serial number"
                                onChange={(e) => {
                                  let fullList = [...items];
                                  let list = [...item.serialNumbers];
                                  list[i].num = e.target.value;
                                  fullList[index].serialNumbers = [...list];
                                  setItems(fullList);
                                }}
                              />
                              <div className="pb-camera">
                                <img
                                  src="/assets/images/camera.png"
                                  onClick={handleImageClick}
                                />
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  style={{ display: "none" }}
                                  onChange={(e) => handleImageChange(e, item, i, index)}
                                  accept="image/*"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <input type="number" value={item.price} readOnly />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={item.price * item.quantity}
                          readOnly
                        />
                      </td>
                      <td>
                        <input type="number" value={item.cgst} readOnly />
                      </td>
                      <td>
                        <input type="number" value={item.sgst} readOnly />
                      </td>
                      <td>
                        <input type="number" value={item.igst} readOnly />
                      </td>
                      <td className="pb-price">
                        ₹
                        {(
                          item.quantity * item.price +
                          (item.quantity * item.price * item.igst) / 100 +
                          (item.quantity * item.price * item.cgst) / 100 +
                          (item.quantity * item.price * item.sgst) / 100
                        ).toFixed(2)}
                      </td>

                      <td>
                        <button onClick={() => handleRemoveRow(index)} className="pb-remove">
                          <i className="fa fa-trash" /> Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {items.length === 0 && (
                <div className="pb-empty">
                  <i className="fa fa-shopping-basket" />
                  <p>No items yet. Pick a product above to add it here.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseBillAdd;
